// src/features/manual/components/StaffBlock.tsx

import React from 'react';
import { useTranslate } from 'react-admin';
import { alpha } from '@mui/material/styles';
import { Box } from '@mui/material';
import { MarkdownBody } from './MarkdownBody';
import { StaffLabel } from './StaffLabel';

interface StaffBlockProps {
  markdown: string;
  anchors?: Map<string, string>;
}

/**
 * «Solo personal de Roommatik»: the dashed box with the notes for Roommatik technicians. The API only
 * sends these blocks to staff; this gives them a look no customer text has, so a technician never
 * mistakes them for what a customer reads.
 */
export const StaffBlock: React.FC<StaffBlockProps> = ({ markdown, anchors }) => {
  const translate = useTranslate();
  return (
    <Box
      component="aside"
      data-staff-block
      aria-label={translate('manual.staff.label')}
      sx={(theme) => ({
        my: 2,
        p: '12px 16px 14px',
        border: `1px dashed ${theme.palette.primary.dark}`,
        borderRadius: theme.custom.radius.card,
        bgcolor: alpha(theme.palette.primary.dark, 0.04),
        '&& h2, && h3, && h4': { ...theme.typography.h5, m: '0 0 6px', fontSize: '0.875rem', fontWeight: 600 },
      })}
    >
      <StaffLabel sx={{ mb: 1 }} />
      <MarkdownBody markdown={markdown} anchors={anchors} />
    </Box>
  );
};

export default StaffBlock;
